window.datepicker = function() {
    const currentLocale = window.locale || 'en';
    const currentDateFormat = window.datepicker_format || 'd-m-Y';

    $(".datepicker").flatpickr({
        allowInput: true,
        dateFormat: currentDateFormat,
        locale: flatpickrLanguageSwitch(currentLocale),
    });
};
